import * as types from 'stores/types';

export function connectWebsocket() {
  return { type: types.WEBSOCKET_CONNECT };
}

export function disconnectWebsocket() {
  return { type: types.WEBSOCKET_DISCONNECT };
}

export function changeStatusWebsocket( data ) {
  return { type: types.WEBSOCKET_CHANGE_STATUS, data };
}

export function sendMessageWebsocket( data ) {
  return { type: types.WEBSOCKET_SEND_MESSAGE, data };
}

export function updateNewMessage( data ) {
  return { type: types.WEBSOCKET_NEW_MESSAGE, data };
}

export function updateNewMessageFile( data ) {
  return { type: types.WEBSOCKET_NEW_MESSAGE_FILE, data };
}

export function setOnline( data ) {
  return { type: types.WEBSOCKET_USER_ONLINE, data };
}

export function setOffline( data ) {
  return { type: types.WEBSOCKET_USER_OFFLINE, data };
}

export function checkUserOnline( data ) {
  return { type: types.WEBSOCKET_CHECK_USER_ONLINE, data };
}



// WEBPACK FOOTER //
// ./stores/actions/common/websocket.js